// Meta Pixel (Facebook Pixel) utilities
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Check if fbq is already loaded
  if (window.fbq) return

  // Load Meta Pixel script
  ;(function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]

    // Insert script - handle case where no script tags exist yet
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      // Fallback: append to head if no script tags exist
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  // Initialize pixel with your ID
  window.fbq('init', '1251535546825451')

  // Track initial PageView
  window.fbq('track', 'PageView')
}

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
